import { Controller } from '@hotwired/stimulus';
import { useResize } from 'stimulus-use';

export default class extends Controller {
    connect() {
        useResize(this);
    }

    resize() {
        this.element.setAttribute('data-overflowing-width', this.element.scrollWidth > this.element.clientWidth);
        this.element.setAttribute('data-overflowing-height', this.element.scrollHeight > this.element.clientHeight);
    }
}
